import Counts2 from './Counts2';

export default Counts2;
